import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
//import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const projectPath = window.location.pathname.split("/").filter(Boolean).pop();
const loadPath = import.meta.env?.VITE_SCROLLABLE_BASE_URL
  ? `${import.meta.env.VITE_SCROLLABLE_BASE_URL}/${projectPath}/locales/{{lng}}/{{ns}}.json`
  : "./locales/{{lng}}/{{ns}}.json";


i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      loadPath: loadPath,
    },
    fallbackLng: "en",
    nsSeparator: "::",
    keySeparator: ".",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    debug: false,
  });

export default i18n;
